import { useEffect, useState } from "react";

const profiles = ["Day Trader", "Long-term Investor", "Crypto Trader", "Forex Trader", "Beginner", "Options Trader", "Swing Trader"];
const brokers = ["Platform #A7●●", "Platform #K2●●", "Platform #M9●●", "Platform #T4●●", "Platform #R8●●"];
const locations = ["Toronto", "Vancouver", "Calgary", "Montreal", "Ottawa", "Edmonton", "Winnipeg", "Halifax"];

const randomMatch = () => ({
  id: Math.random().toString(36).slice(2),
  trader: `Trader #${Math.floor(1000 + Math.random() * 9000)}`,
  profile: profiles[Math.floor(Math.random() * profiles.length)],
  broker: brokers[Math.floor(Math.random() * brokers.length)],
  location: locations[Math.floor(Math.random() * locations.length)],
  score: (92 + Math.random() * 7.9).toFixed(1),
  time: "just now",
});

const initial = Array.from({ length: 7 }, (_, i) => ({
  ...randomMatch(),
  time: i === 0 ? "just now" : `${i * 2 + 1}m ago`,
}));

export const LiveFeed = () => {
  const [rows, setRows] = useState(initial);
  const [matched, setMatched] = useState(12437);

  useEffect(() => {
    const t = setInterval(() => {
      setRows((prev) => [randomMatch(), ...prev.slice(0, 6).map((r) => ({ ...r, time: r.time === "just now" ? "1m ago" : r.time }))]);
      setMatched((m) => m + 1);
    }, 3500);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="live-matches" className="px-4 sm:px-6 pb-16 scroll-mt-32">
      <div className="max-w-4xl mx-auto">
        <div data-testid="live-feed" className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
          <div className="flex flex-wrap items-center justify-between gap-3 px-6 py-4 border-b border-gray-200 bg-gray-900">
            <div className="flex items-center gap-3">
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
              </span>
              <h2 className="font-mono text-sm font-semibold text-white tracking-wider">AI CENTRAL — LIVE MATCHES</h2>
            </div>
            <span data-testid="live-feed-counter" className="font-mono text-xs text-emerald-400">
              {matched.toLocaleString()} traders matched
            </span>
          </div>

          <div className="hidden sm:grid grid-cols-12 px-6 py-3 text-xs font-bold uppercase tracking-[0.15em] text-gray-400 border-b border-gray-100">
            <span className="col-span-3">Trader</span>
            <span className="col-span-3">Profile</span>
            <span className="col-span-3">Matched With</span>
            <span className="col-span-2">Fit Score</span>
            <span className="col-span-1 text-right">Time</span>
          </div>

          <div>
            {rows.map((r, i) => (
              <div
                key={r.id}
                className={`grid grid-cols-2 sm:grid-cols-12 gap-y-1 px-6 py-3.5 text-sm border-b border-gray-50 items-center ${i === 0 ? "feed-row-enter bg-blue-50/50" : ""}`}
              >
                <span className="col-span-1 sm:col-span-3 font-mono font-medium text-gray-900">{r.trader} <span className="text-gray-400 text-xs">· {r.location}</span></span>
                <span className="col-span-1 sm:col-span-3 text-gray-600">{r.profile}</span>
                <span className="col-span-1 sm:col-span-3 font-semibold text-gray-900">{r.broker}</span>
                <span className="col-span-1 sm:col-span-2 font-mono font-bold text-emerald-600">{r.score}%</span>
                <span className="hidden sm:block col-span-1 text-right text-xs text-gray-400">{r.time}</span>
              </div>
            ))}
          </div>

          <p className="px-6 py-3 text-xs text-gray-400 text-center bg-gray-50">
            Simulated matching activity based on recent platform data
          </p>
        </div>
      </div>
    </section>
  );
};
